import { render, staticRenderFns } from "./EditExpenseModal.vue?vue&type=template&id=2349ece9"
import script from "./EditExpenseModal.vue?vue&type=script&lang=ts"
export * from "./EditExpenseModal.vue?vue&type=script&lang=ts"
import style0 from "./EditExpenseModal.vue?vue&type=style&index=0&id=2349ece9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports